import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Paper } from '@mui/material';
import { translation } from 'utils/translate';
import { useSelector } from 'react-redux';
import './Instructions.css';
import { isMobile } from 'react-device-detect';

const videos = [
  {
    title: {
      fi: 'Lakitutkan esittelyvideo',
      se: 'Presentationsvideo för Lagradarn',
    },
    embed_url:
    {
      fi: 'https://www.youtube.com/embed/YDUqkrPtR5o?si=HM85OPyKn0hnAMh',
      se: 'https://www.youtube.com/embed/YDUqkrPtR5o?si=HM85OPyKn0hnAMh&cc_load_policy=1&cc_lang_pref=sv',
    },
    url:
    {
      fi: "https://youtu.be/YDUqkrPtR5o?feature=shared",
      se: "https://youtu.be/YDUqkrPtR5o?feature=shared&cc_load_policy=1&cc_lang_pref=sv",
    }
  },
  {
    title: {
      fi: 'Hakuominaisuudet',
      se: 'Sökfunktioner',
    },
    embed_url:
    {
      fi: 'https://www.youtube.com/embed/koC6m_p7TBs?si=HM85OPyKn0hnAMh',
      se: 'https://www.youtube.com/embed/koC6m_p7TBs?si=HM85OPyKn0hnAMh&cc_load_policy=1&cc_lang_pref=sv',
    },
    url:
    {
      fi: "https://youtu.be/koC6m_p7TBs?feature=shared",
      se: "https://youtu.be/koC6m_p7TBs?feature=shared&cc_load_policy=1&cc_lang_pref=sv",
    }
  },
  {
    title: {
      fi: 'Hakutulosten visualisointi',
      se: 'Visualisering av sökresultat',
    },
    embed_url:
    {
      fi: 'https://www.youtube.com/embed/2Pwjs6OHd0M?si=HM85OPyKn0hnAMh',
      se: 'https://www.youtube.com/embed/2Pwjs6OHd0M?si=HM85OPyKn0hnAMh&cc_load_policy=1&cc_lang_pref=sv',
    },
    url:
    {
      fi: "https://youtu.be/2Pwjs6OHd0M?feature=shared",
      se: "https://youtu.be/2Pwjs6OHd0M?feature=shared&cc_load_policy=1&cc_lang_pref=sv",
    }
  },
];

const Instructions = () => {
  const lang = useSelector((store) => store.lang)
  
  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  return (
    <>
      <Helmet>
        <title>{translation("instructions", "short_title", lang)} | {config.site.name}</title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={0}>
          <div className={isMobile? "page-wrapper-mobile":"page-wrapper"}>
            <h1 className="page-title">
            {translation("instructions", "long_title", lang)}
            </h1>
            <p>
              <a
                className="big-link-centered"
                href={
                  lang === "fi"
                  ? "https://lakitutka.fi/media/Lakitutka_ohjeet.pdf"
                  : "https://lakitutka.fi/media/lagradarn_instruktioner.pdf"
                }
              >
                {translation("instructions", "download_instructions", lang)}
              </a>
            </p>

            {videos.map((video) => (
              <div className="video-centered">
                <h2 className="page-subtitle">
                  {lang === 'se' ? video.title.se : video.title.fi }
                </h2>
                <iframe
                  className="embed-video"
                  title="video"
                  width="700"
                  height="394"
                  src={video.embed_url[lang]}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <p>
                  <a
                    href={video.url[lang]}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {translation("instructions", "open_video", lang)}
                  </a>
                </p>
              </div>
            ))}
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default Instructions;
